import React from "react";
import "../style/Intro.css";
import AOS from "aos";
import profileImg from "../img/ProfilePic.jpeg";
import { Linkedin, EnvelopeFill, Github } from "react-bootstrap-icons";

AOS.init();
const Intro = () => {
  return (
    <div>
      <div className="aboutMe_continer">
        <div data-aos="fade-in" className="aboutMe_div">
          <p className="title_p">Hello World!</p>

          <span className="aboutMeText_p">
            I'm <span className="myName_span">Tomer Asraf</span> , a passionate
            unity developer who loves to design and develop game-focused
            applications.
          </span>
        </div >
        <img className="profile_img" src={profileImg} alt="Profile" />
      </div>


      <div className="links_container">
        <a href="https://github.com/tomerasraf">
          <button className="contactMe_btn">
            <Github size={30} />
          </button>
        </a>

        <a href="https://www.linkedin.com/in/tomerasraf/">
          <button className="contactMe_btn">
            <Linkedin size={30} />
          </button>
        </a>

        <a href="mailto:tomerasraf2@gmail.com">
          <button className="contactMe_btn">
            <EnvelopeFill size={30} />
          </button>
        </a>

        <button className="resume_btn">Resume</button>

      </div>
    </div>
  );
};

export default Intro;
